import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from "react-intl";
import { UncontrolledTooltip } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import {
  ROUTE_ADMIN_USERS_VIEW,
} from '../../../../../../config/routes';
import { history, store } from '../../../../../../store/store';
import { ACL } from '../../../../../../config/constants';
import { hideNotification } from '../../../../../../store/actions/notification';

const ViewUser = ({ user, index }) => {
  if (!ACL.ADMIN.USERS.VIEW.hasAccess()) {
    return null;
  }

  return (
    <Fragment>
      <Link
        to="#"
        className="cursor-pointer mr-2 link-icon-color"
        id={`view-icon-${index}`}
        onClick={(e) => {
          e.preventDefault();
          store.dispatch(hideNotification());
          let url = ROUTE_ADMIN_USERS_VIEW;
          url = url.replace( ":userId", user.id );
          history.push( url );
        }}
      >
        <FontAwesomeIcon
          size="lg"
          className="mr-2 cursor-pointer"
          pointerEvents="none"
          icon={faEye}
        />
      </Link>
      <UncontrolledTooltip
        delay={0}
        target={`view-icon-${index}`}
        modifiers={{
          preventOverflow: {
            enabled: true,
            boundariesElement: "body",
          },
        }}
      >
        <FormattedMessage id="button.view"/>
      </UncontrolledTooltip>
    </Fragment>
  )
}

export {
  ViewUser
};
